let currentCount = 0;

export function getWishlistCount() {
    return currentCount;
}

function formatWishlistCount(count) {
    return count > 99 ? '99+' : String(count);
}

export function updateWishlistCountDisplay(count) {
    currentCount = count;

    const text = count > 0 ? formatWishlistCount(count) : '';
    const method = count > 0 ? 'add' : 'remove';

    document.querySelectorAll('.wishlist-count').forEach(el => { el.textContent = text; });
    document.querySelectorAll('.icon-heart-icon').forEach(el => el.classList[method]('wishlist-count--active'));
}

export async function fetchWishlistCount() {
    const nonce = (typeof decolegnoAjax !== 'undefined' && decolegnoAjax.nonce) ? decolegnoAjax.nonce : '';
    const params = new URLSearchParams({ action: 'get_user_wishlist_count', security: nonce });

    const response = await fetch(ajax_object.ajax_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body: params,
        credentials: 'same-origin',
    }).catch(err => console.error('Failed to fetch wishlist count:', err));

    const data = response && await response.json();
    data?.success && updateWishlistCountDisplay(data.data.wishlist_count);
}

document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', fetchWishlistCount)
    : fetchWishlistCount();
